import { getRandDirection } from "./randomNums";

// Timer
export const TOTAL_TIME = 420;
export const NEW_DATA_EVENT = "NEW_DATA_EVENT";
export const PAUSE_TIMER_EVENT = "PAUSE_TIMER_EVENT";
export const RESUME_TIMER_EVENT = "RESUME_TIMER_EVENT"
// Core(dos) Pesca(nueve) Hangman(ocho) Emit(Seis) Center(diez) Compass(tres) Vicinus(cinco) Charge(cuatro) Edges(siete)

// Level Names
export const LEVEL_NAMES = [
  "",
  "Core",
  "Pesca",
  "Hangman",
  "Emit",
  "Center",
  "Compass",
  "Vicinus",
  "Charge",
  "Edges",
];

// Hints
export const HINTS = [
  [
    "Intersection",
    "Click the tile at the intersection of the arrows", // core
  ],
  [
    "Free the fish. A fish swims to the side it’s facing",
    "Click on the fish that can swim away (and are not blocked)", //pesca
  ],
  [
    "Hang",
    "Hang the 3 on the hook", // hangman
  ],
  [
    "The tile moves in the direction of the arrow lying below it", //vicinus
    "Tap the arrows to make a path for the ball to move out",
  ],
  [
    "Find the odd ones out",
    "Tap on the disks with the black center", // emit
  ],
  [
    "Right Down Left Up",
    "Move around the screen to make everything gray", //compass
  ],
  [
    "You can only tap the neighbours", //charge
    "Find a path to visit all the squares",
  ],
  [
    "Fill battery", // center
    "Fill the left column (Tap Left). Transfer a block right (Tap Center). Move one down on the right column (Tap Right). Repeat",
  ],
  [
    "Each block has a count",
    "Select in increasing order of the number of sides and elements in individual blocks", // edges
  ],
];

// For Level 2
export const TILES = [
  { x: 0, y: 0, filled: false },
  { x: 1, y: 0, filled: false },
  { x: 2, y: 0, filled: false },
  { x: 3, y: 0, filled: false },
  { x: 4, y: 0, filled: false },
  { x: 0, y: 1, filled: false },
  { x: 1, y: 1, filled: false },
  { x: 2, y: 1, filled: false },
  { x: 3, y: 1, filled: false },
  { x: 4, y: 1, filled: false },
  { x: 0, y: 2, filled: false },
  { x: 1, y: 2, filled: false },
  { x: 2, y: 2, filled: false },
  { x: 3, y: 2, filled: false },
  { x: 4, y: 2, filled: false },
  { x: 0, y: 3, filled: false },
  { x: 1, y: 3, filled: false },
  { x: 2, y: 3, filled: false },
  { x: 3, y: 3, filled: false },
  { x: 4, y: 3, filled: false },
  { x: 0, y: 4, filled: false },
  { x: 1, y: 4, filled: false },
  { x: 2, y: 4, filled: false },
  { x: 3, y: 4, filled: false },
  { x: 4, y: 4, filled: false },
];

// For Level 3
export const BG_TILES = [
  { filled: false, x: 0, y: 0 },
  { filled: false, x: 1, y: 0 },
  { filled: false, x: 2, y: 0 },
  { filled: false, x: 3, y: 0 },
  { filled: false, x: 4, y: 0 },

  { filled: false, x: 0, y: 1 },
  { filled: false, x: 1, y: 1 },
  { filled: false, x: 2, y: 1 },
  { filled: false, x: 3, y: 1 },
  { filled: false, x: 4, y: 1 },

  { filled: false, x: 0, y: 2 },
  { filled: false, x: 1, y: 2 },
  { filled: false, x: 2, y: 2 },
  { filled: false, x: 3, y: 2 },
  { filled: false, x: 4, y: 2 },

  { filled: false, x: 0, y: 3 },
  { filled: false, x: 1, y: 3 },
  { filled: false, x: 2, y: 3 },
  { filled: false, x: 3, y: 3 },
  { filled: false, x: 4, y: 3 },

  { filled: false, x: 0, y: 4 },
  { filled: false, x: 1, y: 4 },
  { filled: false, x: 2, y: 4 },
  { filled: false, x: 3, y: 4 },
  { filled: false, x: 4, y: 4 },
];

// For Level 4
export const LEFT_BARS = [false, false, false, false, false, false, false];
export const RIGHT_BARS = [false, false, false, false, false, false, false];

// For Level 6
export const POINTER_DIV = [
  { x: 0, y: 0, direction: getRandDirection() },
  { x: 1, y: 0, direction: getRandDirection() },
  { x: 2, y: 0, direction: getRandDirection() },
  { x: 3, y: 0, direction: getRandDirection() },
  { x: 4, y: 0, direction: getRandDirection() },
  { x: 5, y: 0, direction: getRandDirection() },
  { x: 6, y: 0, direction: getRandDirection() },

  { x: 0, y: 1, direction: getRandDirection() },
  { x: 1, y: 1, direction: getRandDirection() },
  { x: 2, y: 1, direction: getRandDirection() },
  { x: 3, y: 1, direction: getRandDirection() },
  { x: 4, y: 1, direction: getRandDirection() },
  { x: 5, y: 1, direction: getRandDirection() },
  { x: 6, y: 1, direction: getRandDirection() },

  { x: 0, y: 2, direction: getRandDirection() },
  { x: 1, y: 2, direction: getRandDirection() },
  { x: 2, y: 2, direction: getRandDirection() },
  { x: 3, y: 2, direction: getRandDirection() },
  { x: 4, y: 2, direction: getRandDirection() },
  { x: 5, y: 2, direction: getRandDirection() },
  { x: 6, y: 2, direction: getRandDirection() },

  { x: 0, y: 3, direction: getRandDirection() },
  { x: 1, y: 3, direction: getRandDirection() },
  { x: 2, y: 3, direction: getRandDirection() },
  { x: 3, y: 3, direction: getRandDirection() },
  { x: 4, y: 3, direction: getRandDirection() },
  { x: 5, y: 3, direction: getRandDirection() },
  { x: 6, y: 3, direction: getRandDirection() },

  { x: 0, y: 4, direction: getRandDirection() },
  { x: 1, y: 4, direction: getRandDirection() },
  { x: 2, y: 4, direction: getRandDirection() },
  { x: 3, y: 4, direction: getRandDirection() },
  { x: 4, y: 4, direction: getRandDirection() },
  { x: 5, y: 4, direction: getRandDirection() },
  { x: 6, y: 4, direction: getRandDirection() },

  { x: 0, y: 5, direction: getRandDirection() },
  { x: 1, y: 5, direction: getRandDirection() },
  { x: 2, y: 5, direction: getRandDirection() },
  { x: 3, y: 5, direction: getRandDirection() },
  { x: 4, y: 5, direction: getRandDirection() },
  { x: 5, y: 5, direction: getRandDirection() },
  { x: 6, y: 5, direction: getRandDirection() },

  { x: 0, y: 6, direction: getRandDirection() },
  { x: 1, y: 6, direction: getRandDirection() },
  { x: 2, y: 6, direction: getRandDirection() },
  { x: 3, y: 6, direction: getRandDirection() },
  { x: 4, y: 6, direction: getRandDirection() },
  { x: 5, y: 6, direction: getRandDirection() },
  { x: 6, y: 6, direction: getRandDirection() },
];

// For Level 10
export const CIRCLES_ARR = [
  { x: 0, y: 0, type: "empty", hidden: false, popup: false },
  { x: 0, y: 1, type: "empty", hidden: false, popup: false },
  { x: 0, y: 2, type: "empty", hidden: false, popup: false },
  { x: 0, y: 3, type: "empty", hidden: false, popup: false },
  { x: 0, y: 4, type: "empty", hidden: false, popup: false },
  { x: 0, y: 5, type: "empty", hidden: false, popup: false },
  { x: 0, y: 6, type: "dot", hidden: false, popup: false },
  { x: 0, y: 7, type: "empty", hidden: false, popup: false },
  { x: 0, y: 8, type: "empty", hidden: false, popup: false },
  { x: 0, y: 9, type: "empty", hidden: false, popup: false },

  { x: 1, y: 0, type: "empty", hidden: false, popup: false },
  { x: 1, y: 1, type: "empty", hidden: false, popup: false },
  { x: 1, y: 2, type: "empty", hidden: false, popup: false },
  { x: 1, y: 3, type: "dot", hidden: false, popup: false },
  { x: 1, y: 4, type: "empty", hidden: false, popup: false },
  { x: 1, y: 5, type: "empty", hidden: false, popup: false },
  { x: 1, y: 6, type: "empty", hidden: false, popup: false },
  { x: 1, y: 7, type: "empty", hidden: false, popup: false },
  { x: 1, y: 8, type: "empty", hidden: false, popup: false },
  { x: 1, y: 9, type: "empty", hidden: false, popup: false },

  { x: 2, y: 0, type: "empty", hidden: false, popup: false },
  { x: 2, y: 1, type: "empty", hidden: false, popup: false },
  { x: 2, y: 2, type: "empty", hidden: false, popup: false },
  { x: 2, y: 3, type: "empty", hidden: false, popup: false },
  { x: 2, y: 4, type: "empty", hidden: false, popup: false },
  { x: 2, y: 5, type: "dot", hidden: false, popup: false },
  { x: 2, y: 6, type: "empty", hidden: false, popup: false },
  { x: 2, y: 7, type: "empty", hidden: false, popup: false },
  { x: 2, y: 8, type: "empty", hidden: false, popup: false },
  { x: 2, y: 9, type: "empty", hidden: false, popup: false },

  { x: 3, y: 0, type: "empty", hidden: false, popup: false },
  { x: 3, y: 1, type: "empty", hidden: false, popup: false },
  { x: 3, y: 2, type: "dot", hidden: false, popup: false },
  { x: 3, y: 3, type: "empty", hidden: false, popup: false },
  { x: 3, y: 4, type: "empty", hidden: false, popup: false },
  { x: 3, y: 5, type: "empty", hidden: false, popup: false },
  { x: 3, y: 6, type: "empty", hidden: false, popup: false },
  { x: 3, y: 7, type: "empty", hidden: false, popup: false },
  { x: 3, y: 8, type: "empty", hidden: false, popup: false },
  { x: 3, y: 9, type: "empty", hidden: false, popup: false },

  { x: 4, y: 0, type: "empty", hidden: false, popup: false },
  { x: 4, y: 1, type: "empty", hidden: false, popup: false },
  { x: 4, y: 2, type: "empty", hidden: false, popup: false },
  { x: 4, y: 3, type: "empty", hidden: false, popup: false },
  { x: 4, y: 4, type: "empty", hidden: false, popup: false },
  { x: 4, y: 5, type: "empty", hidden: false, popup: false },
  { x: 4, y: 6, type: "empty", hidden: false, popup: false },
  { x: 4, y: 7, type: "dot", hidden: false, popup: false },
  { x: 4, y: 8, type: "empty", hidden: false, popup: false },
  { x: 4, y: 9, type: "empty", hidden: false, popup: false },

  { x: 5, y: 0, type: "empty", hidden: false, popup: false },
  { x: 5, y: 1, type: "empty", hidden: false, popup: false },
  { x: 5, y: 2, type: "empty", hidden: false, popup: false },
  { x: 5, y: 3, type: "empty", hidden: false, popup: false },
  { x: 5, y: 4, type: "empty", hidden: false, popup: false },
  { x: 5, y: 5, type: "empty", hidden: false, popup: false },
  { x: 5, y: 6, type: "empty", hidden: false, popup: false },
  { x: 5, y: 7, type: "dot", hidden: false, popup: false },
  { x: 5, y: 8, type: "empty", hidden: false, popup: false },
  { x: 5, y: 9, type: "empty", hidden: false, popup: false },

  { x: 6, y: 0, type: "empty", hidden: false, popup: false },
  { x: 6, y: 1, type: "empty", hidden: false, popup: false },
  { x: 6, y: 2, type: "empty", hidden: false, popup: false },
  { x: 6, y: 3, type: "dot", hidden: false, popup: false },
  { x: 6, y: 4, type: "empty", hidden: false, popup: false },
  { x: 6, y: 5, type: "empty", hidden: false, popup: false },
  { x: 6, y: 6, type: "empty", hidden: false, popup: false },
  { x: 6, y: 7, type: "empty", hidden: false, popup: false },
  { x: 6, y: 8, type: "empty", hidden: false, popup: false },
  { x: 6, y: 9, type: "empty", hidden: false, popup: false },
];
